module.exports = __webpack_public_path__ + "static/img/dbf.79724e04.png";